import { buttonStyles } from "@components/ui/Button"
import { Icon, IconChevronLeft, IconChevronRight } from "@components/ui/Icon"
import { Select } from "@components/ui/Select"
import dayjs from "dayjs"

type Props = {
  dates: string[]
  value: string
  onValueChange: (date: string) => void
}

function formatDate(date: string) {
  return dayjs(date).format("ddd D MMMM")
}

export function DateNavigator(props: Props) {
  if (!props.dates) return null
  const selectedIndex = props.dates.indexOf(props.value) ?? 0
  const prevDate = selectedIndex > 0 ? props.dates[selectedIndex - 1] : null
  const nextDate = selectedIndex < props.dates.length - 1 ? props.dates[selectedIndex + 1] : null

  return (
    <div className="inline-flex gap-[1px]">
      <button
        className={buttonStyles({ shape: "icon", class: "!rounded-r-none" })}
        disabled={!prevDate}
        onClick={() => prevDate && props.onValueChange(prevDate)}
      >
        <IconChevronLeft data-part="icon" />
      </button>
      <Select
        value={props.value}
        onValueChange={(value) => props.onValueChange(value!)}
        items={props.dates.map((d) => ({ label: formatDate(d), value: d }))}
        className={"!rounded-none [&_[data-part='icon']]:hidden w-[10em]"}
      />
      <button
        className={buttonStyles({ shape: "icon", class: "!rounded-l-none" })}
        disabled={!nextDate}
        onClick={() => nextDate && props.onValueChange(nextDate)}
      >
        <IconChevronRight data-part="icon" />
      </button>
    </div>
  )
}
